import { render, staticRenderFns } from "./AllLeadList.vue?vue&type=template&id=1f980bb7&scoped=true&"
import script from "./AllLeadList.vue?vue&type=script&lang=js&"
export * from "./AllLeadList.vue?vue&type=script&lang=js&"
import style0 from "./AllLeadList.vue?vue&type=style&index=0&id=1f980bb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f980bb7",
  null
  
)

export default component.exports